var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapsFillIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0127 3.5332C12.452 0.0938729 18.0284 0.0938729 21.4678 3.5332C24.9069 6.97249 24.9069 12.548 21.4678 15.9873L15.2402 22.2148C11.8009 25.6542 6.22449 25.6542 2.78516 22.2148C-0.653665 18.7756 -0.653642 13.2 2.78516 9.76074L9.0127 3.5332ZM5.74121 7.5498L17.4512 19.2598L18.5127 18.1992L6.80176 6.48828L5.74121 7.5498Z",
    fill: "#6C6859"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsFillIcon);
export default __webpack_public_path__ + "static/media/CapsFillIcon.ff4440a963ca21887ce07ce9632c0e7b.svg";
export { ForwardRef as ReactComponent };